import { render, staticRenderFns } from "./VariableHospital.vue?vue&type=template&id=430f3dde&"
import script from "./VariableHospital.vue?vue&type=script&lang=js&"
export * from "./VariableHospital.vue?vue&type=script&lang=js&"
import style0 from "./VariableHospital.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports